export default __webpack_public_path__ + "static/media/play-blue.e9630347.svg";